import reduxApi from 'redux-api';
import adapterFetch from './fetchAdapter';
import modulesList from './modules/list';
import modulesGet from './modules/get';
import modulesCreate from './modules/create';
import modulesPatch from './modules/patch';
import accountsGet from './accounts/get';
import accountsPatch from './accounts/patch';
import accountsCreate from './accounts/create';
import accountsList from './accounts/list';
import accountsDischarge from './accounts/discharge';
import progressList from './progress/list';
import progressCreate from './progress/create';
import progressDelete from './progress/delete';
import dischargeProgressList from './dischargeProgress/list';
import dischargeProgressCreate from './dischargeProgress/create';
import dischargeContent from './dischargeContent/list';
import profilesDelete from './profiles/delete';
import profilesList from './profiles/list';
import profilesPatch from './profiles/patch';
import profilesPost from './profiles/post';
import profilesUnlock from './profiles/unlock';
import pinForgot from './pin/forgot';
import pinReset from './pin/reset';
import questionsCreate from './questions/create';
import questionsPatch from './questions/patch';
import questionsList from './questions/list';
import searchGet from './search/get';
import babiesList from './babies/list';
import babiesPatch from './babies/patch';
import babiesCreate from './babies/create';
import entriesList from './entries/list';
import entriesCreate from './entries/create';
import entriesPatch from './entries/patch';
import rolesList from './roles/list';
import invitesCreate from './invites/create';
import invitesRedeem from './invites/redeem';
import invitesVerify from './invites/verify';
import loginsList from './logins/list';
import logoutsList from './logouts/list';
import getHeaders from '../helpers/getHeaders';
import moduleIntroPages from './moduleIntroPages/list';
import dischargeSteps from './dischargeSteps/list';
import glossaryList from './glossary/list';
import subpagesGet from './subpages/list';
import menuList from './menus/list';
import onboardingIntro from './onboardingIntro/list';
import onboardingContent from './onboardingContent/list';
import hasPin from './hasPin/list';
import settingsList from './settings/list';
import videoList from './videos/list';
import formCreate from './forms/create';
import requestsCreate from './requests/create';
import requestsList from './requests/list';
import basicRecords from './basicRecords';
import dietDiaperRecords from './dietDiaperRecords';
import growthRecords from './growthRecords';
import milestoneRecords from './milestoneRecords';
import sleepRecords from './sleepRecords';

export default reduxApi({
  modulesList,
  modulesGet,
  modulesCreate,
  modulesPatch,
  accountsGet,
  accountsPatch,
  accountsCreate,
  accountsList,
  accountsDischarge,
  progressList,
  progressCreate,
  progressDelete,
  dischargeProgressList,
  dischargeProgressCreate,
  dischargeContent,
  profilesDelete,
  profilesList,
  profilesPatch,
  profilesPost,
  profilesUnlock,
  pinForgot,
  pinReset,
  questionsCreate,
  questionsPatch,
  questionsList,
  searchGet,
  babiesList,
  babiesPatch,
  babiesCreate,
  basicRecordsPost: basicRecords.create,
  basicRecordsList: basicRecords.list,
  basicRecordsPatch: basicRecords.patch,
  basicRecordsLatest: basicRecords.latest,
  basicRecordsDelete: basicRecords.delete,
  dietDiaperRecordsPost: dietDiaperRecords.create,
  dietDiaperRecordsList: dietDiaperRecords.list,
  dietDiaperRecordsLatest: dietDiaperRecords.latest,
  dietDiaperRecordsPatch: dietDiaperRecords.patch,
  dietDiaperRecordsDelete: dietDiaperRecords.delete,
  growthRecordsPost: growthRecords.create,
  growthRecordsList: growthRecords.list,
  growthRecordsPatch: growthRecords.patch,
  growthRecordsLatest: growthRecords.latest,
  growthRecordsDelete: growthRecords.delete,
  milestoneRecordsPost: milestoneRecords.create,
  milestoneRecordsList: milestoneRecords.list,
  milestoneRecordsLatest: milestoneRecords.latest,
  milestoneRecordsPatch: milestoneRecords.patch,
  milestoneRecordsDelete: milestoneRecords.delete,
  sleepRecordsPost: sleepRecords.create,
  sleepRecordsList: sleepRecords.list,
  sleepRecordsPatch: sleepRecords.patch,
  sleepRecordsLatest: sleepRecords.latest,
  sleepRecordsDelete: sleepRecords.delete,
  entriesList,
  entriesCreate,
  entriesPatch,
  rolesList,
  invitesCreate,
  invitesRedeem,
  invitesVerify,
  loginsList,
  logoutsList,
  moduleIntroPages,
  dischargeSteps,
  glossaryList,
  subpagesGet,
  menuList,
  onboardingIntro,
  hasPin,
  settingsList,
  onboardingContent,
  videoList,
  formCreate,
  requestsCreate,
  requestsList
})
  .use('options', (url, params, getState) =>
    getHeaders(getState() && getState().auth.token)
  )
  .use('fetch', adapterFetch(fetch));
